module.exports = __webpack_public_path__ + "static/media/text-component.ca77c460.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/text-component.scss
// module id = 54
// module chunks = 0